import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/@core/services/notification.service';
import { AppService } from 'src/@core/services/app.service';
import { API_SERRI_BULK_CAMPAIGN, API_SERRI_CONNECT_TO_PROJECT, API_SERRI_LIST_ACCOUNTS, API_SERRI_LIST_TEMPLATES, API_WHATSAPP_DISCONNECT_FROM_PROJECT, API_WHATSAPP_LIST_WABAs, API_WHATSAPP_CONNECT_TO_PROJECT, API_WHATSAPP_CONNECT_INTERAKT, PROJECT_API_KEY } from 'src/@core/services/util/api.endpoints';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hour4u-admin-waba-connect-dialog',
  templateUrl: './waba-connect-dialog.component.html',
  styleUrls: ['./waba-connect-dialog.component.scss']
})
export class WABAConnectDialogComponent implements OnInit {
  wabaList: any[] = [];
  isLoading: boolean = false;
  isConnecting: boolean = false;
  isConnectingInterakt: boolean = false;
  isConnectingSerri: boolean = false;
  isConnectingBridge: boolean = false;
  isDisconnecting: boolean = false;
  selectedWABA: any = null;
  entityId: string = '';
  serriWhatsappPhoneNumber: string = '';
  serriAccounts: any[] = [];
  connectedWhatsappVendor: string = '';
  connectedWhatsappPhoneNumber: string = '';
  serriTemplates: any[] = [];
  isLoadingSerriTemplates: boolean = false;
  selectedSerriTemplateName: string = '';
  serriBulkExcludeOptOuts: boolean = true;
  serriBulkDeliveryMode: string = 'BULK';
  serriBulkClickTrackingRedirectUrl: string = '';
  serriBulkClickTrackingVariableIndex: number = 0;
  isSendingSerriBulkCampaign: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<WABAConnectDialogComponent>,
    private http: HttpClient,
    private notificationService: NotificationService,
    private appService: AppService,
    @Inject(MAT_DIALOG_DATA) public data: {
      entity_id?: string;
      project_id: string;
      whatsapp_vendor?: string;
      whatsapp_phone_number?: string;
    }
  ) {
    this.entityId = this.data.entity_id || this.appService.getEntityId();
    this.connectedWhatsappVendor = this.data.whatsapp_vendor || '';
    this.connectedWhatsappPhoneNumber = this.data.whatsapp_phone_number || '';
  }

  ngOnInit() {
    if (this.entityId) {
      this.fetchWABAs();
      this.fetchSerriAccounts();
      this.fetchSerriTemplates();
    }
  }

  hasConnectedWhatsapp(): boolean {
    return !!(this.connectedWhatsappVendor || this.connectedWhatsappPhoneNumber);
  }

  isSerriConnected(): boolean {
    return (this.connectedWhatsappVendor || '').toLowerCase().includes('serri');
  }

  getSelectedSerriTemplate(): any {
    if (!this.selectedSerriTemplateName) {
      return null;
    }
    return (this.serriTemplates || []).find((t: any) => t && t.name === this.selectedSerriTemplateName) || null;
  }

  fetchSerriTemplates() {
    if (!this.entityId) {
      return;
    }

    const whatsappPhoneNumber = (this.connectedWhatsappPhoneNumber || '').trim();
    if (!whatsappPhoneNumber) {
      this.serriTemplates = [];
      this.selectedSerriTemplateName = '';
      return;
    }

    this.isLoadingSerriTemplates = true;

    const params = new URLSearchParams({
      entity_id: this.entityId,
      whatsapp_phone_number: whatsappPhoneNumber,
      page: '1',
      limit: '25'
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const listTemplatesUrl = `${API_SERRI_LIST_TEMPLATES}?${params.toString()}`;

    this.http.get(listTemplatesUrl, { headers }).subscribe({
      next: (response: any) => {
        this.isLoadingSerriTemplates = false;

        let templates: any[] = [];
        if (response && response.success && response.data && response.data.data && Array.isArray(response.data.data)) {
          templates = response.data.data;
        } else if (response && response.success && response.data && Array.isArray(response.data)) {
          templates = response.data;
        } else if (Array.isArray(response)) {
          templates = response;
        }

        const approvedTemplates = templates.filter((t: any) => t && (t.status === 'APPROVED' || !t.status));
        this.serriTemplates = approvedTemplates.map((t: any) => ({
          ...t,
          name: t.name || t.label || 'Template'
        }));

        if (!this.selectedSerriTemplateName && this.serriTemplates.length > 0) {
          this.selectedSerriTemplateName = this.serriTemplates[0].name;
        }
      },
      error: (err: any) => {
        this.isLoadingSerriTemplates = false;
        console.error('Error loading Serri templates:', err);
        this.serriTemplates = [];
        this.selectedSerriTemplateName = '';
      }
    });
  }

  fetchWABAs() {
    if (!this.entityId) {
      this.notificationService.showMessage('Entity ID not found. Cannot fetch WABAs.', 3000);
      return;
    }

    this.isLoading = true;

    const params = new URLSearchParams({
      entity_id: this.entityId
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const listWABAsUrl = `${API_WHATSAPP_LIST_WABAs}?${params.toString()}`;

    this.http.get(listWABAsUrl, { headers }).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        console.log('WABAs list response:', response);

        if (response && response.success && response.data && Array.isArray(response.data)) {
          this.wabaList = response.data;
        } else {
          this.wabaList = [];
        }
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error fetching WABAs list:', err);
        const errorMessage = err.error && err.error.message
          ? err.error.message
          : 'Failed to fetch WABAs. Please try again.';
        this.notificationService.showMessage(errorMessage, 5000);
        this.wabaList = [];
      }
    });
  }

  fetchSerriAccounts() {
    if (!this.entityId) {
      return;
    }

    const params = new URLSearchParams({
      entity_id: this.entityId
    });

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const listAccountsUrl = `${API_SERRI_LIST_ACCOUNTS}?${params.toString()}`;

    this.http.get(listAccountsUrl, { headers }).subscribe({
      next: (response: any) => {
        console.log('Serri accounts response:', response);

        let accounts: any[] = [];

        if (response && response.success && response.data && Array.isArray(response.data)) {
          accounts = response.data;
        } else if (Array.isArray(response)) {
          accounts = response;
        }

        this.serriAccounts = accounts || [];

        if (this.serriAccounts.length > 0 && !this.serriWhatsappPhoneNumber) {
          const first = this.serriAccounts[0];
          this.serriWhatsappPhoneNumber = first.whatsapp_phone_number || first.phone_number || '';
        }
      },
      error: (err: any) => {
        console.error('Error fetching Serri accounts:', err);
        // Non-blocking: just log, no toast to avoid noise
      }
    });
  }

  selectWABA(waba: any) {
    this.selectedWABA = waba;
  }

  connectWABA() {
    if (this.hasConnectedWhatsapp()) {
      this.notificationService.showMessage('A WhatsApp number is already connected. Please disconnect first.', 3000);
      return;
    }
    if (!this.selectedWABA) {
      this.notificationService.showMessage('Please select a WABA to connect.', 3000);
      return;
    }

    if (!this.data.project_id) {
      this.notificationService.showMessage('Project ID not found.', 3000);
      return;
    }

    this.isConnecting = true;

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    // Prepare body - can use either phone_number_id OR waba_id
    const body: any = {
      entity_id: this.entityId,
      project_id: this.data.project_id
    };

    // Use phone_number_id if available, otherwise use waba_id
    if (this.selectedWABA.phone_number_id) {
      body.phone_number_id = this.selectedWABA.phone_number_id;
    } else if (this.selectedWABA.waba_id) {
      body.waba_id = this.selectedWABA.waba_id;
    }

    this.http.post(API_WHATSAPP_CONNECT_TO_PROJECT, body, { headers }).subscribe({
      next: (response: any) => {
        this.isConnecting = false;
        console.log('Connect WABA response:', response);

        if (response && response.success) {
          this.notificationService.showMessage(
            response.message || 'WABA connected to project successfully!',
            3000
          );
          this.dialogRef.close({ success: true, message: response.message, waba: this.selectedWABA });
        } else {
          const errorMessage = response.message || 'Failed to connect WABA to project.';
          this.notificationService.showMessage(errorMessage, 5000);
        }
      },
      error: (err: any) => {
        this.isConnecting = false;
        console.error('Error connecting WABA:', err);
        const errorMessage = err.error && err.error.message
          ? err.error.message
          : 'Failed to connect WABA to project. Please try again.';
        this.notificationService.showMessage(errorMessage, 5000);
      }
    });
  }

  formatTimestamp(timestamp: number): string {
    if (!timestamp) return '-';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  connectInterakt() {
    if (this.hasConnectedWhatsapp()) {
      this.notificationService.showMessage('A WhatsApp number is already connected. Please disconnect first.', 3000);
      return;
    }
    if (!this.data.project_id) {
      this.notificationService.showMessage('Project ID not found.', 3000);
      return;
    }

    if (!environment.interaktApiKey) {
      this.notificationService.showMessage('Interakt API Key not configured. Please contact support.', 5000);
      return;
    }

    this.isConnectingInterakt = true;

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const body = {
      entity_id: this.entityId,
      project_id: this.data.project_id,
      interakt_api_key: environment.interaktApiKey
    };

    this.http.post(API_WHATSAPP_CONNECT_INTERAKT, body, { headers }).subscribe({
      next: (response: any) => {
        this.isConnectingInterakt = false;
        console.log('Connect Interakt response:', response);

        if (response && response.success) {
          this.notificationService.showMessage(
            response.message || 'Interakt connected to project successfully!',
            3000
          );
          this.dialogRef.close({ success: true, message: response.message, provider: 'interakt' });
        } else {
          const errorMessage = response.message || 'Failed to connect Interakt to project.';
          this.notificationService.showMessage(errorMessage, 5000);
        }
      },
      error: (err: any) => {
        this.isConnectingInterakt = false;
        console.error('Error connecting Interakt:', err);
        const errorMessage = err.error && err.error.message
          ? err.error.message
          : 'Failed to connect Interakt to project. Please try again.';
        this.notificationService.showMessage(errorMessage, 5000);
      }
    });
  }

  connectWhatsappBridge() {
    if (this.hasConnectedWhatsapp()) {
      this.notificationService.showMessage('A WhatsApp number is already connected. Please disconnect first.', 3000);
      return;
    }
    if (!this.data.project_id) {
      this.notificationService.showMessage('Project ID not found.', 3000);
      return;
    }

    this.isConnectingBridge = true;
    // For now, just route the action back to the project details component,
    // which already contains the QR-session popup flow (authenticateWhatsapp()).
    this.dialogRef.close({ action: 'whatsapp_bridge' });
  }

  sendSerriBulkCampaign() {
    if (!this.isSerriConnected()) {
      return;
    }
    if (!this.entityId) {
      this.notificationService.showMessage('Entity ID not found.', 3000);
      return;
    }
    if (!this.data.project_id) {
      this.notificationService.showMessage('Project ID not found.', 3000);
      return;
    }
    if (!this.selectedSerriTemplateName || this.selectedSerriTemplateName.trim() === '') {
      this.notificationService.showMessage('Please select a template.', 3000);
      return;
    }

    this.isSendingSerriBulkCampaign = true;

    let headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });
    const authToken = localStorage.getItem('jwtToken');
    if (authToken) {
      headers = headers.set('Authorization', `Bearer ${authToken}`);
    }

    const body = {
      entity_id: this.entityId,
      project_id: this.data.project_id,
      template_name: this.selectedSerriTemplateName.trim(),
      exclude_opt_outs: !!this.serriBulkExcludeOptOuts,
      delivery_mode: this.serriBulkDeliveryMode || 'BULK',
      click_tracking_redirect_url: (this.serriBulkClickTrackingRedirectUrl || '').trim(),
      click_tracking_variable_index: Number(this.serriBulkClickTrackingVariableIndex) || 0
    };

    this.http.post(API_SERRI_BULK_CAMPAIGN, body, { headers }).subscribe({
      next: (response: any) => {
        this.isSendingSerriBulkCampaign = false;
        if (response && response.success) {
          this.notificationService.showMessage(response.message || 'Bulk campaign started!', 3000);
        } else {
          this.notificationService.showMessage((response && response.message) || 'Failed to start bulk campaign.', 5000);
        }
      },
      error: (err: any) => {
        this.isSendingSerriBulkCampaign = false;
        const errorMessage = err.error && err.error.message
          ? err.error.message
          : 'Failed to start bulk campaign. Please try again.';
        this.notificationService.showMessage(errorMessage, 5000);
      }
    });
  }

  connectSerri() {
    if (this.hasConnectedWhatsapp()) {
      this.notificationService.showMessage('A WhatsApp number is already connected. Please disconnect first.', 3000);
      return;
    }
    if (!this.data.project_id) {
      this.notificationService.showMessage('Project ID not found.', 3000);
      return;
    }

    if (!this.serriWhatsappPhoneNumber || this.serriWhatsappPhoneNumber.trim() === '') {
      this.notificationService.showMessage('Please enter a WhatsApp phone number.', 3000);
      return;
    }

    this.isConnectingSerri = true;

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const body = {
      entity_id: this.entityId,
      project_id: this.data.project_id,
      whatsapp_phone_number: this.serriWhatsappPhoneNumber.trim()
    };

    this.http.post(API_SERRI_CONNECT_TO_PROJECT, body, { headers }).subscribe({
      next: (response: any) => {
        this.isConnectingSerri = false;
        console.log('Connect Serri response:', response);

        if (response && response.success) {
          this.notificationService.showMessage(
            response.message || 'Serri connected to project successfully!',
            3000
          );
          this.dialogRef.close({ success: true, message: response.message, provider: 'serri' });
        } else {
          const errorMessage = response && response.message ? response.message : 'Failed to connect Serri to project.';
          this.notificationService.showMessage(errorMessage, 5000);
        }
      },
      error: (err: any) => {
        this.isConnectingSerri = false;
        console.error('Error connecting Serri:', err);
        const errorMessage = err.error && err.error.message
          ? err.error.message
          : 'Failed to connect Serri to project. Please try again.';
        this.notificationService.showMessage(errorMessage, 5000);
      }
    });
  }

  disconnectWhatsapp() {
    if (!this.data.project_id) {
      this.notificationService.showMessage('Project ID not found.', 3000);
      return;
    }

    if (!this.entityId) {
      this.notificationService.showMessage('Entity ID not found.', 3000);
      return;
    }

    this.isDisconnecting = true;

    const authToken = localStorage.getItem('jwtToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${authToken}`,
      'x-api-key': PROJECT_API_KEY,
      'x-suppress-error': 'true'
    });

    const body = {
      entity_id: this.entityId,
      project_id: this.data.project_id
    };

    this.http.post(API_WHATSAPP_DISCONNECT_FROM_PROJECT, body, { headers }).subscribe({
      next: (response: any) => {
        this.isDisconnecting = false;
        console.log('Disconnect WhatsApp response:', response);
        if (response && response.success) {
          this.notificationService.showMessage(response.message || 'WhatsApp disconnected successfully!', 3000);
          this.dialogRef.close({ success: true, message: response.message, action: 'disconnected' });
        } else {
          const errorMessage = response && response.message ? response.message : 'Failed to disconnect WhatsApp.';
          this.notificationService.showMessage(errorMessage, 5000);
        }
      },
      error: (err: any) => {
        this.isDisconnecting = false;
        console.error('Error disconnecting WhatsApp:', err);
        const errorMessage = err.error && err.error.message
          ? err.error.message
          : 'Failed to disconnect WhatsApp. Please try again.';
        this.notificationService.showMessage(errorMessage, 5000);
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}

